'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _colors = require('HubStyleTokens/colors');

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIFormControl = require('UIComponents/form/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _UIStepperInput = require('UIComponents/input/UIStepperInput');

var _UIStepperInput2 = _interopRequireDefault(_UIStepperInput);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UITile = require('UIComponents/tile/UITile');

var _UITile2 = _interopRequireDefault(_UITile);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _PricingSelectors = require('../../selectors/PricingSelectors');

var _merchandiseUtils = require('../../utils/merchandiseUtils');

var merchandiseUtils = _interopRequireWildcard(_merchandiseUtils);

var _PriceDisplay = require('./pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _pricingUtils = require('../../utils/pricingUtils');

var _itemConfigUtils = require('../../utils/itemConfigUtils');

var _H = require('UIComponents/elements/headings/H5');

var _H2 = _interopRequireDefault(_H);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subtext = (0, _styledComponents2.default)(_FormattedJSXMessage2.default).withConfig({
  displayName: 'SeatsPicker__Subtext'
})(['font-size:12px;line-height:20px;color:', ';display:block;max-width:260px;margin-right:20px;'], _colors.EERIE);

var StyledTile = (0, _styledComponents2.default)(_UITile2.default).withConfig({
  displayName: 'SeatsPicker__StyledTile'
})(['margin-top:24px;font-size:12px;text-align:center;padding:8px;']);

var SmallHeader = _styledComponents2.default.span.withConfig({
  displayName: 'SeatsPicker__SmallHeader'
})(['font-size:14px;font-weight:600;']);

function SeatsPicker(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      merchandiseId = _ref.merchandiseId,
      onChange = _ref.onChange,
      term = _ref.term,
      termId = _ref.termId,
      pricingDependencies = _ref.pricingDependencies,
      hideFreeUsersDisclaimer = _ref.hideFreeUsersDisclaimer,
      useHubSpecificTitle = _ref.useHubSpecificTitle;
  var currencyCode = pricingDependencies.currencyCode;

  var billingNameKey = merchandiseUtils.billingNameKey(merchandiseId);
  var minPurchasableSeats = merchandiseUtils.includedAdditionalUnits(merchandiseId);

  var additionalUnitPrice = (0, _pricingUtils.calculatePrice)(_extends({}, pricingDependencies, {
    term: term,
    termId: termId,
    merchandiseId: merchandiseId,
    itemConfigurations: (0, _itemConfigUtils.defaultAdditionalSeatsUnitItemConfig)(merchandiseId)
  })).monthly.calculatedPrice;

  var roundValue = function roundValue(_ref2) {
    var value = _ref2.target.value;

    var roundedValue = Math.round(value);
    var nextAdditionalUnitQuantity = roundedValue < minPurchasableSeats ? minPurchasableSeats : roundedValue;
    nextAdditionalUnitQuantity = nextAdditionalUnitQuantity - minPurchasableSeats;
    onChange(nextAdditionalUnitQuantity);
  };

  return _react2.default.createElement(
    'div',
    null,
    useHubSpecificTitle ? _HubMap2.default[_Hubs2.default.HUB_SALES].merchandise.includes(merchandiseId) ? _react2.default.createElement(
      SmallHeader,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.seats.hubSpecificTitles.sales' })
    ) : _react2.default.createElement(
      SmallHeader,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.seats.hubSpecificTitles.service' })
    ) : _react2.default.createElement(
      _H2.default,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.seats.title' })
    ),
    _react2.default.createElement(
      _UIFlex2.default,
      { direction: 'row', justify: 'between', align: 'center' },
      _react2.default.createElement(
        _Small2.default,
        { style: { paddingRight: '15px' } },
        _react2.default.createElement(Subtext, {
          message: 'pricingPage.calculator.seats.subtext.' + billingNameKey + '_jsx',
          elements: { PriceDisplay: _PriceDisplay2.default },
          options: { currencyCode: currencyCode, price: additionalUnitPrice }
        })
      ),
      _react2.default.createElement(
        _UIFormControl2.default,
        null,
        _react2.default.createElement(_UIStepperInput2.default, {
          style: { width: '100px' },
          disabled: !merchandiseId,
          value: additionalUnitQuantity + minPurchasableSeats,
          min: minPurchasableSeats,
          onChange: roundValue,
          'data-selenium-id': 'seats-picker-input'
        })
      )
    ),
    !hideFreeUsersDisclaimer && _react2.default.createElement(
      StyledTile,
      null,
      _react2.default.createElement(
        'b',
        null,
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.seats.unlimitedFreeUsers.title' })
      ),
      _react2.default.createElement(_FormattedMessage2.default, {
        className: 'm-left-1',
        style: { color: '' + _colors.EERIE },
        message: 'pricingPage.calculator.seats.unlimitedFreeUsers.text'
      })
    )
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SeatsPicker);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/SeatsPicker.js
// module id = 248
// module chunks = 3 4